import { addPermissionsToRoute } from '@qsrsoft/myq-core';
const routes = {
  name: 'Cash',
  icon: 'mdi-cash',
  path: '/reports/cash',
  children: [
    // {
    //   path: '/reports/cash/taxDetails',
    //   name: 'Tax Details',
    //   meta: { id: 'mc-taxDetails', permission: 'cash' },
    //   component: () => import('./TaxDetails.vue'),
    //   ...addPermissionsToRoute(['cash']),
    // },
    {
      path: '/reports/cash/tax',
      name: 'Tax Exempt',
      meta: { id: 'mc-taxExempt', permission: 'cash' },
      component: () => import('./tax/TaxWrapper.vue'),
      ...addPermissionsToRoute(['cash']),
    },
    {
      path: '/reports/cash/registerAudit',
      name: 'Register Audit',
      meta: { id: 'mc-registerAudit', permission: 'cash' },
      component: () => import('./RegisterAudit.vue'),
      ...addPermissionsToRoute(['cash']),
    },
    // {
    //   path: '/reports/cash/cashless',
    //   name: 'Cashless',
    //   meta: { id: 'mc-cashless', permission: 'cash' },
    //   component: () => import('./CashlessWrapper.vue'),
    //   ...addPermissionsToRoute(['cash']),
    // },
    // {
    //   path: '/reports/cash/giftCardSummary',
    //   name: 'Gift Card Summary',
    //   meta: { id: 'mc-giftCardSummary', permission: 'cash' },
    //   component: () => import('./GiftCardSummary.vue'),
    //   ...addPermissionsToRoute(['cash']),
    // },
  ],
};

export default routes;
